var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActive
    ? _c(
        "div",
        {
          staticClass: "ekomi-container",
          on: { mouseenter: _vm.onMouseenter, mouseleave: _vm.onMouseleave }
        },
        [
          _c(
            "a",
            {
              staticClass: "ekomi-link",
              attrs: {
                href: _vm.url,
                title: `Bewertung: ${_vm.rating}`,
                target: "_blank"
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.onClick.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "ekomi-stars-gray",
                  style: _vm.getStarsGrayStyles()
                },
                [
                  _c("span", {
                    staticClass: "ekomi-stars-yellow",
                    style: _vm.getStarsYellowStyles()
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.isPopupInfoEnabled
            ? _c("div", { staticClass: "ekomi-popup-info" }, [
                _vm._v("\r\n        Bewertungen: "),
                _c("b", [_vm._v(_vm._s(_vm.rating))]),
                _vm._v(
                  " / 5\r\n        -\r\n        " +
                    _vm._s(_vm.reviews) +
                    " Rezensionen\r\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailInfoEnabled
            ? _c("div", { staticClass: "ekomi-detail-info" }, [
                _c("b", [_vm._v(_vm._s(_vm.rating))]),
                _vm._v(
                  " / 5\r\n        basierend auf\r\n        " +
                    _vm._s(_vm.reviews) +
                    " Bewertungen\r\n    "
                )
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }